export interface AssetVideo {
  url?: string;
  assetId?: string;
  description?: string;
  provider?: string;
}

export type VideoValue = AssetVideo;

function readRecord(value: unknown): Record<string, unknown> | undefined {
  if (value && typeof value === 'object' && !Array.isArray(value)) {
    return value as Record<string, unknown>;
  }

  return undefined;
}

export function normalizeVideoValue(value: unknown): VideoValue | undefined {
  const record = readRecord(value);
  if (!record) {
    return undefined;
  }

  const url = typeof record.url === 'string' ? record.url : undefined;
  const assetId = typeof record.assetId === 'string' ? record.assetId : undefined;
  const description = typeof record.description === 'string' ? record.description : undefined;
  const provider = typeof record.provider === 'string' ? record.provider : undefined;

  if (!url && !assetId) {
    return undefined;
  }

  return {
    url,
    assetId,
    description,
    provider,
  };
}

export function getVideoUrl(video: VideoValue | undefined | null): string | undefined {
  if (!video) {
    return undefined;
  }

  return video.url;
}
